// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  url_photo : getUrlPhoto(),
  url: getEnv(),
  production: false,
};

export function getEnv() {
  const env = localStorage.getItem('env');
  let url = 'https://apidev.kahpoo.com/api';
  if ( env === 'dev') {
    url = 'https://apidev.kahpoo.com/api';
  }
  if ( env === 'local') {
    url = 'http://localhost:8080/api';
  }
  if ( env === 'recette') {
    url = 'https://apirecette.kahpoo.com/api';
  }
  if ( env === 'qualification') {
    url = 'https://qualification.kahpoo.com/api';
  }
  if ( env === 'production') {
    url = 'https://www.kahpoo.com/api';
  }
  return url;
}

export function getUrlPhoto() {
  const env = localStorage.getItem('env');
  let url = 'https://dev.kahpoo.com/user-photos/';
  if ( env === 'dev') {
    url = 'https://dev.kahpoo.com/user-photos/';
  }
  if ( env === 'local') {
    url = 'https://dev.kahpoo.com/user-photos/';
  }
  if ( env === 'recette') {
    url = 'https://recette.kahpoo.com/user-photos/';
  }
  if ( env === 'qualification') {
    url = 'https://qualification.kahpoo.com/user-photos/';
  }
  if ( env === 'production') {
    url = 'https://www.kahpoo.com/user-photos/';
  }
  return url;
}

// export function getUrlPhoto() {
//   const env = localStorage.getItem('env');
//   let url = 'https://apidev.kahpoo.com/user-photos/';
//   if ( env === 'dev') {
//     url = 'https://apidev.kahpoo.com/user-photos/';
//   }
//   if ( env === 'local') {
//     url = 'https://apidev.kahpoo.com/user-photos/';
//   }
//   if ( env === 'recette') {
//     url = 'https://apirecette.kahpoo.com/user-photos/';
//   }
//   if ( env === 'qualification') {
//     url = 'https://qualification.kahpoo.com/user-photos/';
//   }
//   if ( env === 'production') {
//     url = 'https://www.kahpoo.com/user-photos/';
//   }
//   return url;
// }



/*
  url: 'http://localhost:8080/api',

  url: localStorage.getItem('env') === 'recette' ? 'https://apirecette.kahpoo.com/api' : 'https://apidev.kahpoo.com/api',

 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
